import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DoNotDisturbOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"do_not_disturb_off"}/>
}
